import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import AdminNavBar from "./AdminNavBar";
import { handleBackToSiteMaterial } from "../adminHelper";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import adminUseFetchBookChapters from "../../custom_hook/adminUseFetchBookChapters";
import adminUseFetchChapterSolutions from "../../custom_hook/adminUseFetchChapterSolutions";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";

const AdminSolutionView = () => {
  const { bookId, chapterId, solutionId } = useParams();

  const { book } = adminUseFetchBookChapters(bookId || "");
  const { chapter, solutions } = adminUseFetchChapterSolutions(chapterId || "");
  const navigate = useNavigate();

  const fetchedSolution = solutions.find(
    (solution: any) => solution.id == parseInt(solutionId || "")
  );

  const [solution, setSolution] = useState({
    exercise_type: "",
    exercise_number: "",
    answer: "",
  });

  useEffect(() => {
    if (fetchedSolution) {
      setSolution({
        exercise_type: fetchedSolution.exercise_type,
        exercise_number: fetchedSolution.exercise_number,
        answer: fetchedSolution.answer,
      });
    }
  }, [fetchedSolution]);

  return (
    <>
      <nav className="navbar navbar-dark bg-dark">
        <AdminNavBar />
      </nav>
      <nav id="bc-nav" aria-label="breadcrumb">
        <ol id="bc-ol" className="breadcrumb">
          <li id="bc-books" className="breadcrumb-item">
            <button
              className="inactive-anchor-link"
              onClick={() => {
                handleBackToSiteMaterial(navigate);
              }}
            >
              Site Materials
            </button>{" "}
            <span className="greater-than">&#x02AA2;</span>
          </li>
          <Link
            to={`/admin/site-materials/books`}
            className="breadcrumb-item inactive-anchor-link"
          >
            Books <span className="greater-than">&#x02AA2;</span>
          </Link>
          <Link
            to={`/admin/site-materials/books/${book?.id}/chapters`}
            className="breadcrumb-item inactive-anchor-link"
          >
            {book?.title} <span className="greater-than">&#x02AA2;</span>
          </Link>
          <Link
            to={`/admin/site-materials/books/${book?.id}/chapters/${chapter?.id}/solutions`}
            className="breadcrumb-item inactive-anchor-link"
          >
            {chapter?.title} <span className="greater-than">&#x02AA2;</span>
          </Link>
          <li id="bc-active" className="breadcrumb-item active">
            {solution.exercise_type} {solution.exercise_number}
          </li>
        </ol>
      </nav>
      <div id="answer-main-container">
        <div id="answer-container">
          <h4>
            {solution.exercise_type} {solution.exercise_number}
          </h4>
          <ReactMarkdown
            className="markdown"
            children={solution.answer}
            remarkPlugins={[remarkGfm, remarkMath]}
            rehypePlugins={[rehypeRaw, rehypeKatex]}
          />
        </div>
      </div>
    </>
  );
};

export default AdminSolutionView;
